// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_AlbumLink_hyperlink__-Trp8"};